import { SVGAttributes } from 'react';

const CircleInfo = (props: SVGAttributes<HTMLOrSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
  >
    <path
      d="M2.34262 14.1569C5.46686 17.2808 10.5324 17.2812 13.6569 14.1569C16.7812 11.0327 16.7808 5.96721 13.657 2.84262C10.5327 -0.28093 5.46721 -0.281278 2.34262 2.84261C-0.781276 5.9672 -0.780929 11.0324 2.34262 14.1569ZM6.95663 5.02145C6.95663 4.44508 7.42377 3.97794 8.00013 3.97794C8.57649 3.97794 9.04363 4.44508 9.04363 5.02145L9.04363 9.19545C9.04363 9.77181 8.57649 10.239 8.00013 10.239C7.42377 10.2389 6.95663 9.77181 6.95663 9.19545L6.95663 5.02145ZM8.01857 10.9791C8.61962 10.9791 9.02033 11.4049 9.00781 11.9305C9.02033 12.4814 8.61962 12.8943 8.00639 12.8943C7.39281 12.8943 7.00463 12.4811 6.99176 11.9305C6.99211 11.4049 7.39247 10.9791 8.01857 10.9791Z"
      fill="currentColor"
    />
  </svg>
);

export default CircleInfo;
